import React from 'react';

export default () => (
  <div className="tvt-not-allowed">
    <span className="glyphicon glyphicon-lock" />
    <p>Oops, looks like you dont have permission</p>
    <p>Contact us to learn more about this report</p>
  </div>
);
